import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_HOST;

const getAuthHeaders = () => {
  const token = localStorage.getItem("access_token");
  return { Authorization: token ? `Bearer ${token}` : "" };
};

export const getMagnusteam = async ({ limit = 10, page = 1, search = "" }) => {
  const response = await axios.get(`${API_BASE_URL}/team`, {
    params: { limit, page, search },
    headers: getAuthHeaders(),
  });
  return response.data;
};


export const addTeamMember = async (formData) => {
  const response = await axios.post(`${API_BASE_URL}/team/add`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const updateTeamMember = async (formData) => {
  const response = await axios.post(`${API_BASE_URL}/team/update`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const getTeamMemberById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/team/show/${id}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const deleteTeamMember = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/team/delete/${id}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};